export function wickedpicker() {
  if ($('.js-wickedpicker').length) {
    $('.js-wickedpicker').each(function(idx,ele){

      var time_val=$('.js-wickedpicker').eq(idx).val();
      
      if(!time_val){
        time_val = "00:00";
      }

      var options = {
        now: time_val, //hh：mm 24時間形式のみ、デフォルトは現在時刻
        twentyFour: true, //24時間形式を表示します。デフォルトはfalseです。
        title: '時間入力', //Wickedpickerのタイトル
        minutesInterval: 1, //分間隔を変更します。デフォルトは1です。
      };
  
      $('.js-wickedpicker').eq(idx).wickedpicker(options);
    });
  }
}
